import dayjs from 'dayjs';

const nights: dayjs.PluginFunc = (_, dayjsClass) => {
  dayjsClass.prototype.nights = function nights(end: dayjs.ConfigType) {
    return getNights(this, end);
  };
};
dayjs.extend(nights);

export function getNights(
  start: dayjs.ConfigType = new Date(),
  end: dayjs.ConfigType = new Date()
) {
  return Math.abs(
    Math.floor(
      dayjs(start).startOf('day').diff(dayjs(end).startOf('day'), 'day')
    )
  );
}
